// extracted by mini-css-extract-plugin
export default {"button":"ct_dQ","buttonLeft":"ct_kk","buttonRight":"ct_kl","icon":"ct_js"};